<div id="ssoMenu">
  <div
    nz-dropdown
    *ngIf="(modelManagementLink || oneAccessLink) && globalSettingsReady"
    [nzDropdownMenu]="menu"
    nzPlacement="bottomRight"
    nzTrigger="click"
  >
    <va-icon
      isFontAwesome="true"
      [name]="faCaretCircleDown"
      class="fa-lg right-icon display-icon"
    ></va-icon>
    <span class="header-menu-text user-name">Insights</span>
    <va-icon
      size="small"
      name="chevron-down"
      class="my-class display-chevronDown-icon"
    ></va-icon>
  </div>
  <nz-dropdown-menu #menu="nzDropdownMenu">
    <ul nz-menu class="sso-menu-list">
      <li class="logo-item">
        <div class="img-container">
          <img
            class="VA_logo"
            src="{{
              assetUrl
            }}/VisibleAlpha_transition_no_padding_spg_pos_rgb.svg"
            alt="Visible Alpha now a part of S&P Global Market Intelligence"
          />
        </div>
      </li>
      <li nz-menu-item><b>Insights</b></li>
      <li nz-menu-item *ngIf="modelManagementLink != ''">
        <a href="{{ modelManagementLink }}">Model Management</a>
      </li>
      <li nz-menu-item *ngIf="oneAccessLink != ''">
        <a href="{{ oneAccessLink }}">Interactions (ONEaccess)</a>
      </li>
    </ul>
  </nz-dropdown-menu>
</div>
